import { 
  collection, 
  getDocs, 
  addDoc, 
  deleteDoc, 
  doc, 
  query, 
  where,
  onSnapshot,
  writeBatch,
  setDoc
} from 'firebase/firestore';
import { db } from './config';

const ACTIVITIES_COLLECTION = 'activities';

export async function getActivities() {
  try {
    const activitiesSnapshot = await getDocs(collection(db, ACTIVITIES_COLLECTION));
    return activitiesSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error("Error getting activities:", error);
    throw error;
  }
}

export function subscribeToActivities(callback) {
  const q = collection(db, ACTIVITIES_COLLECTION);
  return onSnapshot(q, (snapshot) => {
    const activities = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(activities);
  });
}

export async function addActivity(activity) {
  try {
    const docRef = await addDoc(collection(db, ACTIVITIES_COLLECTION), activity);
    return { id: docRef.id, ...activity };
  } catch (error) {
    console.error("Error adding activity:", error);
    throw error;
  }
}

export async function updateActivity(activityId, updatedActivity) {
  try {
    const activityRef = doc(db, ACTIVITIES_COLLECTION, activityId);
    await setDoc(activityRef, updatedActivity, { merge: true });
    return activityId;
  } catch (error) {
    console.error("Error updating activity:", error);
    throw error;
  }
}

export async function deleteActivity(activityId) {
  try {
    const activityRef = doc(db, ACTIVITIES_COLLECTION, activityId);
    await deleteDoc(activityRef);
  } catch (error) {
    console.error("Error deleting activity:", error);
    throw error;
  }
}

export async function clearAllActivities() {
  try {
    const batch = writeBatch(db);
    const snapshot = await getDocs(collection(db, ACTIVITIES_COLLECTION));
    
    snapshot.docs.forEach((doc) => {
      batch.delete(doc.ref);
    });
    
    await batch.commit();
    console.log('All activities cleared successfully');
  } catch (error) {
    console.error("Error clearing activities:", error);
    throw error;
  }
}

export async function getActivitiesBySkill(skill) {
  try {
    const q = query(
      collection(db, ACTIVITIES_COLLECTION),
      where('SkillTags', '==', skill)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error("Error getting activities by skill:", error);
    throw error;
  }
} 